import { IconStorage } from "../../interfaces";

export const alignLeftV1: IconStorage = {
  svgCode: () => ([
    "M3 3V21M21 12H7M7 12L14 19M7 12L14 5",
  ]),
};

export const alignRightV1: IconStorage = {
  svgCode: () => ([
    "M21 21V3M3 12H17M17 12L10 5M17 12L10 19",
  ]),
};
